// extracted by mini-css-extract-plugin
export default {"wrapper":"Cart_wrapper__I8Hu9","cart":"Cart_cart__ImZm5","closeImg":"Cart_closeImg__VZjKV","header":"Cart_header__srMna","cost":"Cart_cost__6fxGh"};